import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Roundtripcabbookingmumbai() {



  const cardData =
  {
    keyword: 'Round Trip Cab Booking Mumbai ',
    heading: 'Shambhu Cabs: Round Trip Cab Booking Mumbai',
    headingDescription: 'Shambhu Cabs offers dependable Round Trip Cab Booking in Mumbai, providing comfortable and stress-free travel for families, tourists, business travelers, and weekend explorers. Whether you are planning a short city-to-city journey or a multi-day outstation trip, our round-trip cab service ensures a smooth and enjoyable experience with clean, well-maintained vehicles and professional chauffeurs. Shambhu Cabs provides a wide fleet of hatchbacks, sedans, SUVs, and tempo travellers, allowing you to choose the perfect cab for your travel needs. With doorstep pickup across Mumbai, Thane, and Navi Mumbai, transparent pricing, flexible scheduling, and 24/7 customer support, your round-trip travel becomes simple, safe, and convenient. Whether it’s a pilgrimage visit, business tour, hill station getaway, or family vacation, Shambhu Cabs delivers trusted round trip cab booking services in Mumbai designed for comfort, reliability, and a memorable journey.',

    top: 'Top Places to Visit in Mumbai with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924 to commemorate the visit of King George V and Queen Mary, is one of Mumbai’s most iconic landmarks. Located on the waterfront in Colaba, it features grand arches in Indo-Saracenic style, offering panoramic views of the Arabian Sea. The surrounding area is lively with street vendors, boat rides to Elephanta Island, and cultural performances, making it a must-visit for tourists exploring Mumbai’s heritage and coastal beauty."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, also known as the Queen’s Necklace, is a 3.6 km long boulevard along the Arabian Sea. Famous for its Art Deco buildings and stunning sunset views, it attracts joggers, families, and tourists. The promenade lights up at night, giving it the appearance of a string of pearls. Marine Drive is perfect for leisurely walks, photography, and experiencing Mumbai’s vibrant coastal life."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "CSMT, formerly Victoria Terminus, is a UNESCO World Heritage Site and one of India’s busiest railway stations. Built in 1887 in Victorian Gothic style with domes, turrets, and intricate stone carvings, it is an architectural marvel. The station symbolizes Mumbai’s colonial past and modern connectivity, serving as both a transportation hub and a tourist attraction admired for its historical and cultural significance."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple, dedicated to Lord Ganesha, is one of Mumbai’s most revered religious sites. Located in Prabhadevi, it attracts thousands of devotees daily who seek blessings and fulfillment of wishes. The temple’s idol, adorned with gold, intricate carvings, and beautiful decorations, creates a spiritual and serene atmosphere. Festivals, especially Ganesh Chaturthi, see grand celebrations, making it a cultural and religious landmark."
  },
  {
    "title": "Elephanta Caves",
    "description": "Elephanta Caves, located on Elephanta Island near Mumbai, are UNESCO World Heritage Sites featuring rock-cut sculptures dedicated to Lord Shiva. Dating back to the 5th-8th centuries, the caves showcase intricate carvings such as the Trimurti statue, depicting the Hindu trinity. Visitors reach the island by ferry from the Gateway of India, making it a historical, cultural, and scenic destination combining art, mythology, and maritime beauty."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah is a mosque and tomb situated on an islet off the coast of Worli, accessible via a narrow causeway. Dedicated to Sufi saint Pir Haji Ali Shah Bukhari, it attracts pilgrims and tourists from around the world. The white marble structure, set against the Arabian Sea, is especially picturesque during high tide and sunset. It is a symbol of Mumbai’s religious harmony and spiritual heritage."
  },
  {
    "title": "Chor Bazaar",
    "description": "Chor Bazaar, meaning 'Thieves Market,' is one of Mumbai’s oldest and largest flea markets, famous for antiques, vintage items, Bollywood memorabilia, and curiosities. The bustling market is a treasure trove for collectors, photographers, and bargain hunters. Strolling through its narrow lanes, visitors experience the vibrant chaos, history, and culture of Mumbai’s trading legacy, making it a must-visit for shoppers seeking unique finds."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most popular beaches, known for its vibrant street food, sunset views, and lively atmosphere. Locals and tourists flock here to enjoy snacks like pav bhaji, bhel puri, and ice cream while walking along the shore. The beach is also home to cultural events, kite flying, and recreational activities, offering a relaxing escape from the bustling city life and a perfect spot for family outings and photography."
  },
  {
    "title": "Mount Mary Church",
    "description": "Mount Mary Basilica, located in Bandra, is a Roman Catholic church renowned for its serene ambiance, beautiful architecture, and annual Bandra Fair. The church attracts pilgrims and tourists alike, offering stunning views of the surrounding hills and sea. Its blend of Gothic and modern architecture, along with the spiritual atmosphere, makes it a must-visit destination for those exploring Mumbai’s religious and cultural heritage."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park, located in the northern suburbs of Mumbai, is a lush green sanctuary spanning over 100 square kilometers. It houses diverse flora and fauna, including leopards, deer, and various bird species. The park features the Kanheri Caves, trekking trails, boating, and safari options. It serves as a natural escape from the urban hustle, offering wildlife encounters, historical exploration, and outdoor adventure for families and nature enthusiasts."
  }
],




"services": [
  {
    "name": "Round Trip Taxi Mumbai",
    "description": "Round Trip Taxi Mumbai offers convenient and reliable transportation for travelers who require a return journey from Mumbai to their destination. This service ensures timely pickup and drop, well-maintained vehicles, and professional chauffeurs for a comfortable experience. Ideal for family trips, business travel, and leisure excursions, customers can choose from sedans, SUVs, and luxury cars with options for AC or non-AC rides. Flexible booking, transparent pricing, and 24×7 availability make it perfect for both short and long-distance round trips."
  },
  {
    "name": "Mumbai Return Trip Cab",
    "description": "Mumbai Return Trip Cab provides a hassle-free solution for travelers planning a round journey from Mumbai. With experienced drivers, well-maintained vehicles, and multiple cab categories including sedans and SUVs, this service prioritizes comfort, safety, and punctuality. Suitable for airport transfers, city tours, and outstation travel, the service also allows online booking with instant confirmation and flexible scheduling for stress-free travel."
  },
  {
    "name": "Best Round Trip Cab Service Mumbai",
    "description": "Best Round Trip Cab Service Mumbai offers top-rated, professional taxi services for customers looking for quality and reliability on return journeys. Vehicles are maintained to high standards, drivers are courteous and experienced, and the service ensures timely pickups and drops. Options include AC sedans, SUVs, and premium cars, making it suitable for family trips, corporate travel, or leisure excursions. Transparent pricing and online booking add extra convenience."
  },
  {
    "name": "Affordable Round Trip Taxi",
    "description": "Affordable Round Trip Taxi Mumbai provides cost-effective options for travelers seeking comfortable round trips without overspending. With a fleet of sedans, hatchbacks, and SUVs, customers can choose from self-drive or chauffeur-driven options. Transparent fare estimates, flexible booking, and 24×7 service ensure an economical yet reliable travel experience for local and outstation journeys from Mumbai."
  },
  {
    "name": "Mumbai Round Trip AC Cab",
    "description": "Mumbai Round Trip AC Cab offers comfortable and climate-controlled rides for round trips, ensuring passengers travel in a cool and relaxed environment. Available in sedans, SUVs, and premium cars, the service includes professional drivers trained for intercity travel, timely pickups, and secure online booking. Ideal for family trips, corporate travel, and leisure tours, it combines comfort, safety, and convenience."
  },
  {
    "name": "Sedan Round Trip Cab",
    "description": "Sedan Round Trip Cab Mumbai specializes in providing smooth and comfortable round trips in well-maintained sedan vehicles. Perfect for small families, business travelers, or couples, the service includes experienced drivers, round-the-clock support, and easy online booking. Transparent pricing and timely pickups make it a reliable choice for both local and outstation return trips."
  },
  {
    "name": "SUV Round Trip Taxi Mumbai",
    "description": "SUV Round Trip Taxi Mumbai offers spacious and comfortable rides suitable for families, groups, and long-distance travel. Equipped with modern amenities and experienced chauffeurs, this service ensures a safe and relaxed journey for round trips. Flexible booking options, transparent pricing, and 24×7 availability make it ideal for leisure trips, business travel, and weekend getaways from Mumbai."
  },
  {
    "name": "Family Round Trip Cab",
    "description": "Family Round Trip Cab Mumbai is designed to provide safe, comfortable, and convenient travel for families. With spacious sedans and SUVs, professional drivers, and well-maintained vehicles, this service ensures enjoyable round trips for sightseeing, leisure travel, or airport transfers. Transparent fare estimates, flexible booking, and 24×7 customer support make it perfect for family outings from Mumbai."
  },
  {
    "name": "24×7 Round Trip Cab Mumbai",
    "description": "24×7 Round Trip Cab Mumbai provides round-the-clock access to reliable round trip taxis. Passengers can book at any time of the day or night and choose from sedans, SUVs, or premium cars. Professional drivers, punctual pickups, and fully maintained vehicles ensure a comfortable journey. This service is suitable for urgent travel, late-night airport transfers, and flexible outstation round trips."
  },
  {
    "name": "Outstation Round Trip Cab Mumbai",
    "description": "Outstation Round Trip Cab Mumbai offers long-distance travel options for passengers planning return trips from Mumbai to other cities or towns. The service includes sedans, SUVs, and premium cars with experienced chauffeurs for safe and comfortable journeys. Transparent fare structures, flexible scheduling, and online booking ensure smooth travel for corporate trips, leisure vacations, or family excursions."
  },
  {
    "name": "Mumbai Weekend Round Trip Taxi",
    "description": "Mumbai Weekend Round Trip Taxi caters to travelers looking for short getaways over the weekend. With comfortable vehicles, experienced drivers, and flexible itineraries, this service provides convenient round trips to nearby destinations. Options include sedans, SUVs, and luxury cars with online booking, transparent pricing, and 24×7 support, making weekend trips stress-free and enjoyable."
  },
  {
    "name": "Premium Round Trip Cab",
    "description": "Premium Round Trip Cab Mumbai offers luxury and comfort for travelers seeking a high-end experience. Featuring top-end sedans, SUVs, and executive vehicles, the service includes professional chauffeurs, fully maintained interiors, and 24×7 customer support. Ideal for business travel, VIP trips, or special occasions, this service ensures stylish, safe, and comfortable round trips."
  },
  {
    "name": "Fast Round Trip Cab Booking",
    "description": "Fast Round Trip Cab Booking Mumbai allows customers to quickly reserve a round trip taxi with instant confirmation. The service provides a wide selection of vehicles including sedans, SUVs, and luxury cars, all with professional drivers. Ideal for urgent trips, airport transfers, or business travel, the service guarantees timely pickups, safe journeys, and hassle-free online booking."
  },
  {
    "name": "Safe Round Trip Taxi Mumbai",
    "description": "Safe Round Trip Taxi Mumbai prioritizes passenger safety for all round trips from Mumbai. Experienced drivers, well-maintained vehicles, and adherence to traffic and safety regulations ensure a secure journey. Available in sedans, SUVs, and premium cars, the service caters to families, corporate clients, and leisure travelers with transparent pricing and 24×7 customer support."
  },
  {
    "name": "Online Round Trip Cab Mumbai",
    "description": "Online Round Trip Cab Mumbai provides easy digital booking for round trips from Mumbai. Customers can select from a variety of vehicles including sedans, SUVs, and luxury cars, schedule pickups and drops, and pay securely online. The service combines convenience, reliability, and transparency, making it ideal for both local and outstation round trips."
  },
  {
    "name": "Round Trip Travel Cab",
    "description": "Round Trip Travel Cab Mumbai offers a comprehensive travel solution for round trips, including family outings, business trips, and leisure excursions. With well-maintained sedans, SUVs, and premium vehicles, professional drivers, and flexible scheduling, passengers can enjoy a comfortable, safe, and stress-free journey. 24×7 booking and customer support add extra convenience."
  },
  {
    "name": "Corporate Round Trip Cab Mumbai",
    "description": "Corporate Round Trip Cab Mumbai provides tailored transportation solutions for businesses requiring round trip travel. Services include employee commutes, airport transfers, client pickups, and long-distance corporate travel. With professional drivers, premium vehicles, flexible scheduling, and transparent pricing, companies can ensure safe, comfortable, and timely travel for their employees and clients."
  }
],

"tableData": [
  ["Round Trip Taxi Mumbai", "Mumbai Return Trip Cab"],
  ["Best Round Trip Cab Service Mumbai", "Affordable Round Trip Taxi"],
  ["Mumbai Round Trip AC Cab", "Sedan Round Trip Cab"],
  ["SUV Round Trip Taxi Mumbai", "Family Round Trip Cab"],
  ["24×7 Round Trip Cab Mumbai", "Outstation Round Trip Cab Mumbai"],
  ["Mumbai Weekend Round Trip Taxi", "Premium Round Trip Cab"],
  ["Fast Round Trip Cab Booking", "Safe Round Trip Taxi Mumbai"],
  ["Online Round Trip Cab Mumbai", "Round Trip Travel Cab"],
  ["Corporate Round Trip Cab Mumbai", "—"]
],



"whychoose": [
  {
    "WhyChooseheading": "Round Trip Cab Booking in Mumbai with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers convenient round trip cab booking in Mumbai, ideal for airport transfers, city tours, and hassle-free travel."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in spacious, air-conditioned, and regularly serviced cabs to enjoy a smooth and comfortable round trip experience in Mumbai."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Efficient Travel",
    "WhyChoosedescription": "Our professional drivers are familiar with Mumbai routes, ensuring timely, safe, and stress-free round trip journeys."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "We offer clear and upfront pricing—fuel, tolls, and driver allowances included—making your round trip cab booking in Mumbai worry-free."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, travel inquiries, and real-time updates."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for Round Trips",
    "WhyChoosedescription": "Choose from hourly, daily, or customized rental plans tailored to your round trip travel needs in Mumbai."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making your round trip in Mumbai smooth, comfortable, and worry-free."
  }
]






















  }

const faqData = [
  {
    question: 'Does Shambhu Cabs provide round trip cab booking services in Mumbai?',
    answer: 'Yes, Shambhu Cabs offers convenient and reliable round trip cab services in Mumbai, ensuring a comfortable ride to your destination and back.',
  },
  {
    question: 'How can I book a round trip cab in Mumbai with Shambhu Cabs?',
    answer: 'You can book easily through our website, mobile app, or by contacting our 24x7 customer support team for quick and hassle-free round trip bookings.',
  },
  {
    question: 'What types of vehicles are available for round trip cab bookings in Mumbai?',
    answer: 'Shambhu Cabs provides sedans, SUVs, and premium cars suitable for individual, family, and corporate round trips in Mumbai.',
  },
  {
    question: 'Are drivers experienced for round trip cab services in Mumbai?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with Mumbai city routes to ensure a safe and timely journey for both legs of your trip.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations for round trip cab bookings?',
    answer: 'Absolutely. You can select any pickup point and specify your drop-off location for both the onward and return journey.',
  },
  {
    question: 'Is round trip cab service available 24x7 in Mumbai?',
    answer: 'Yes, Shambhu Cabs provides round-the-clock round trip cab services to suit your schedule and travel plans.',
  },
  {
    question: 'Are safety and hygiene protocols followed for round trip cab bookings in Mumbai?',
    answer: 'All vehicles are sanitized regularly, and drivers follow strict safety and hygiene measures to ensure passenger well-being throughout the journey.',
  },
  {
    question: 'What payment options are available for round trip cab bookings in Mumbai?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate account payments for round trip cab services.',
  },
  {
    question: 'Is customer support available during round trip cab journeys in Mumbai?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your round trip cab journey in Mumbai.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sameer Patel',
    feedback: 'Shambhu Cabs’ round trip service in Mumbai was excellent. Punctual, comfortable, and hassle-free experience.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anjali Rao',
    feedback: 'Highly recommend Shambhu Cabs for round trip cab bookings in Mumbai. Smooth ride and professional service throughout.',
    rating: 5,
  },
];























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Round Trip Cab Booking Mumbai",
  "image": "https://www.shambhucab.com/assets/images/round-trip-cab-mumbai.jpg",
  "description": "Shambhu Cabs offers convenient round trip cab booking services in Mumbai. Choose from sedans, SUVs, and AC cabs for family trips, corporate travel, weekend getaways, and outstation journeys. Reliable, safe, and available 24×7 with online booking options.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5300",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1800",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/round-trip-cab-booking-mumbai"
  }
};





  return (
    <div>
<Helmet>
  <title>Round Trip Cab Booking Mumbai | Family & Corporate Travel | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book round trip cab services in Mumbai with Shambhu Cabs. Sedans, SUVs, and AC cabs for family trips, corporate travel, weekend getaways, and outstation journeys. Safe, reliable, and available 24×7 with online booking."
  />

  <meta
    name="keywords"
    content="Round Trip Taxi Mumbai, Mumbai Return Trip Cab, Best Round Trip Cab Service Mumbai, Affordable Round Trip Taxi, Mumbai Round Trip AC Cab, Sedan Round Trip Cab, SUV Round Trip Taxi Mumbai, Family Round Trip Cab, 24×7 Round Trip Cab Mumbai, Outstation Round Trip Cab Mumbai, Mumbai Weekend Round Trip Taxi, Premium Round Trip Cab, Fast Round Trip Cab Booking, Safe Round Trip Taxi Mumbai, Online Round Trip Cab Mumbai, Round Trip Travel Cab, Corporate Round Trip Cab Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/37.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Roundtripcabbookingmumbai;